<button nz-button (click)="openPopup()" [nzSize]="size" nzShape="circle" nz-tooltip [nzTooltipTitle]="'WORKSHOP_TREE.View_tree' | translate">
  <i nz-icon nzType="partition" nzTheme="outline"></i>
</button>
